import React from 'react';
import { ConsentPageContent } from 'services/content';
import styles from './style.module.css';
import { useFormik } from 'formik';
import { putPatientConsent } from 'services/api';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AUTH_ERROR } from 'helpers/types';

const Consent = () => {
  const patient = useSelector((state) => state.patient.patientInfo);
  const isP9 = useSelector((state) => state.patient.isP9);
  const dispatch = useDispatch();
  const infoAndEmailText = isP9
    ? ConsentPageContent.subHeadingText2.concat(
        patient.email
          ? `<span class="${styles.text_email}" >
${patient.email}
</span>`
          : ''
      )
    : ConsentPageContent.subHeadingTextP5;
  const history = useHistory();

  const formik = useFormik({
    initialValues: {
      'consent-user-research': '',
      'consent-marketing': '',
    },
    onSubmit: async (values) => {
      const reqBody = {
        news_email_consent: String(values['consent-marketing']) === 'on',
        order_updates_push_notification_consent: false,
        user_research_email_consent: String(values['consent-user-research']) === 'on',
      };
      try {
        await putPatientConsent(reqBody);
        history.push(isP9 ? '/pharmacy/dashboard' : '/pharmacy/dashboard/add-medication');
      } catch (error) {
        history.push('/pharmacy/error');
        dispatch({ type: AUTH_ERROR, payload: error });
      }
    },
  });
  return (
    <div className="coop-l-container">
      <form onSubmit={formik.handleSubmit} className={`${styles.consent_page} coop-l-medium-8 coop-l-large-8`}>
        <h1>{ConsentPageContent.headingText}</h1>
        <h2 className={styles.sub_header}>{ConsentPageContent.subeadingText1}</h2>
        <p
          className={styles.intro_text}
          dangerouslySetInnerHTML={{
            __html: infoAndEmailText,
          }}
        />
        <hr className={styles.consent_seperator} />
        <ul className={styles.info_container}>
          <h2 className={styles.info_container__header}>{ConsentPageContent.infoHeadingText}</h2>
          <li>
            <div className={`${styles.info_container__section} coop-form__choice`}>
              <input
                id="consent-user-research"
                className={`coop-form__field coop-form__checkbox ${styles.info_container__input}`}
                checked={String(formik.values['consent-user-research']) === 'on'}
                onChange={formik.handleChange}
                type="checkbox"
              />
              <label
                id="label-consent-user-research"
                htmlFor="consent-user-research"
                className={`${styles.info_container__choice} coop-form__label hp-t-body`}
                dangerouslySetInnerHTML={{ __html: ConsentPageContent.consentText1 }}
              />
            </div>
          </li>
          <li>
            <div className="coop-form__choice">
              <input
                id="consent-marketing"
                className={`coop-form__field coop-form__checkbox ${styles.info_container__input}`}
                checked={String(formik.values['consent-marketing']) === 'on'}
                onChange={formik.handleChange}
                type="checkbox"
              />
              <label
                id="label-consent-marketing"
                htmlFor="consent-marketing"
                className={`${styles.info_container__choice} coop-form__label hp-t-body`}
                dangerouslySetInnerHTML={{ __html: ConsentPageContent.consentText2 }}
              />
            </div>
          </li>
        </ul>
        <button type="submit" className={`coop-btn coop-btn--primary ${styles.button}`} id="continuelink">
          {ConsentPageContent.continueButtonText}
        </button>
        <p dangerouslySetInnerHTML={{ __html: ConsentPageContent.externalLinksHTML }} />
      </form>
    </div>
  );
};

export default Consent;
